/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: schema.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  GetSchemaRequest,
  GetSchemaResponse,
  ListSchemaVersionsRequest,
  ListSchemaVersionsResponse,
} from '../types/schema';

export const createSchemaService = (transport: Transport) => ({
  async getSchema(
    request: GetSchemaRequest,
    options: RequestOptions = {},
  ): Promise<GetSchemaResponse> {
    const { organization_id, program_id, workflow_id, ...params } = request;
    const url = getApiPath(API_METHODS.SchemaService.GetSchema, {
      organization_id,
      program_id,
      workflow_id,
    });
    return transport.get<GetSchemaResponse>(url, { params, ...options });
  },

  async listSchemaVersions(
    request: ListSchemaVersionsRequest,
    options: RequestOptions = {},
  ): Promise<ListSchemaVersionsResponse> {
    const { organization_id, program_id, workflow_id, ...params } = request;
    const url = getApiPath(API_METHODS.SchemaService.ListSchemaVersions, {
      organization_id,
      program_id,
      workflow_id,
    });
    return transport.get<ListSchemaVersionsResponse>(url, { params, ...options });
  },
});

export type SchemaService = ReturnType<typeof createSchemaService>;
